import React, { Component } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import { connect } from 'react-redux';
import { R, A, BlessLink } from '../routes';
import Butt from '../c/Butt';
import { StockCard, PortfolioCard } from '../c/ChartCard';
import { T } from '../traks';
import API from '../API';
import { Apify, ApifyFullScreenLoadingComponent } from '../Apify';
import InlineSVG from '../c/InlineSVG';
import { StartedGame, PublicGames, ActiveGameSummary, QuotesFromPeople } from '../c/Game';
import { AUAContainer } from '../AUA';
import { SkinWrapperByGameOrPortfolioId, SR } from '../skin';
import RandomNumberGenerator from '../c/RandomNumberGenerator';
import OurAdSense from '../c/OurAdSense.js';
import { ordered_and_available_market_ids } from '../markets.js';
import GoogleAnalytics from '../GoogleAnalytics';
import Twitter from '../Twitter';
import Linkedin from '../Linkedin';
import InspirationCards from '../c/Inspiration';
import AgeControl from '../c/AgeControl';
import { site_name } from '../Site';
import DynamicBiatheElems from '../c/DynamicBiatheElems';

class CreatePortfolio extends Component {
	constructor(props) {
		super(props);
		this.state = {name: null};
	}

	render() {
		if (this.state.name === null) {
			/*
			const click = () => {
				this.setState({name: ""});
			}
			return <div className="pl-1 pt-3"><Butt onClick={click}><T>Create portfolio</T></Butt></div>;
			*/
			return null;
		} else {
			const change = (e) => {
				this.setState({name: e.target.value});
			}
			const create = () => {
				API.post("/a/new_portfolio", {name: this.state.name}, () => {
					this.setState({name: null});
					this.props.refresh();
				})
			}
			const cancel = () => {
				this.setState({name: null});
			}
			const name = this.state.name;
			return (
				<div>
					<div className="pb-3">
						<T><input className="ad_input ad_new_portfolio_input pl-3" placeholder="Name your portfolio" value={name} onChange={change}/></T>
					</div>
					<Butt onClick={create}><T>Create</T></Butt>
					<span className="pr-3"/>
					<Butt onClick={cancel}><T>Cancel</T></Butt>
				</div>
			);
		}
	}
}



class EmailRequiredInner extends Component {
	constructor(props) {
		super(props);
		this.state = {email: "", err: ""};
	}

	render() {
		const submit = (e) => {
			e.preventDefault();
			if (this.state.email.trim().length === 0) {
				this.setState({err: "no_value"});
			} else {
				const { aua } = this.props;
				aua.request.set_email_password(null, this.state.email, null, false, (err) => {
					if (err) {
						this.setState({err: err.code});
					} else {
						// unreachable; we should always get back here via oauth; i.e. the page will reload
					}
				});
			}
		};
		const change = (e) => {
			this.setState({[e.target.name]: e.target.value});
		};

		var error_element;
		switch (this.state.err) {
		case "":
			break;
		case "no_value":
			error_element = <span>You have not entered an email address</span>
			break;
		case "email_invalid":
			error_element = <span>The entered email address is invalid</span>
			break;
		case "email_conflict":
			error_element = <span>The email is already taken</span>
			break;
		default:
			error_element = <span>{this.state.err}</span>
			break;
		}
		var input_class = "ad_input ad_w_25 ad_border_radius_025rem p-2 mb-3 mb-md-0";
		if (error_element) {
			input_class += " ad_input_error";
			error_element = <div className="errors">{error_element}</div>
		}

		var email_placeholder = <T>Enter your email</T>;
		email_placeholder = this.props.render_static(email_placeholder);

		return (
			<Container fluid className="pt-4 px-0 pb-0">
				<Row className="py-4 px-3 ad_game_box">
					<Col className="px-0">
						<div>
							<Row className="pb-3">
								<Col xs="auto">
									<img alt="problem" className="ad_48px" src="/gfx/problem-icon-0.svg"/>
								</Col>
								<Col>
									<div>
									<b className="ad_little_larger_txt"><T>We need your email address</T></b>
									</div>
									<div className="font-small"><T>
									To be eligible for winning a prize we need your email address. See <A href="/termsofuse"
									alt="termslink">terms</A> for more.
									</T></div>
								</Col>
							</Row>
							<Row>
								<Col xs="12">
									<form onSubmit={submit}>
										<span className="pr-3 pb-3"><input
											className={input_class}
											type="email"
											placeholder={email_placeholder}
											name="email"
											value={this.state.email}
											onChange={change}/>
										</span>
										<Butt className="px-3 mb-1" type="submit">Send</Butt>
										{error_element}
									</form>
								</Col>
							</Row>
						</div>
					</Col>
				</Row>
			</Container>
		);
	}
}

const EmailRequired = (props) => <AUAContainer><EmailRequiredInner {...props}/></AUAContainer>

const get_game_counts_from_sections = (sections) => {
	var prestart = 0;
	var started = 0;
	var ended = 0;
	for (const section of sections) {
		switch (section.Type) {
		case "MY_GAMES_COUNT":
			prestart = section.Content.prestart;
			started = section.Content.started;
			ended = section.Content.ended;
			break;
		default:
			break;
		}
	}
	return {prestart, started, ended, total: prestart+started+ended};
};

var PersonalHome = (props) => {
	const set_birthday = (payload) => API.post("/a/birthdate", {date: payload}, () => window.location.reload());

	if(props.me.Over18 === null) return <AgeControl set_birthday={set_birthday} />;

	const render_summary = () => {
		var active_game;
		for (const section of props.home.Sections) {
			switch (section.Type) {
			case "ACTIVE_GAME":
				if (section.Content.State === 'started') {
					active_game = section.Content;
				}
				break;
			default:
				break;
			}
		}

		if (active_game) {
			GoogleAnalytics.game_impression(active_game.Id);
		}

		const game_counts = get_game_counts_from_sections(props.home.Sections);
		const show_game_change_button = game_counts.prestart > 0 || game_counts.started > 0 || game_counts.ended > 0;

		var game_element;
		if (active_game) game_element = <StartedGame me={props.me} game={active_game}/>;

		var pretop;
		if (active_game && active_game.RequireEmail && !props.me.LocalEmail) pretop = <EmailRequired/>

		let adpartnerelement;
		if ((!active_game || active_game.ShowStandardAds) && IS_INVESTSPIEL_DE) {
			adpartnerelement = (
				<Container>
					<Row className="pt-4 pb-2">
						<Col xs="12">
							<div className="text-center">
								<OurAdSense dataAdSlot="3174985804" />
							</div>
						</Col>
					</Row>
				</Container>
			);
		}

		return (
			<Container className="p-0">
				{SR.render_game_header()}
				{pretop}
				<ActiveGameSummary me={props.me} game={active_game} show_game_change_button={show_game_change_button}/>
				{adpartnerelement}
				{game_element}
			</Container>
		);
	};

	const render_other_stuff = () => {
		var sections = [];

		const game_counts = get_game_counts_from_sections(props.home.Sections);

		if (game_counts.started === 0) {
			var new_game_button_text;
			if (game_counts.ended === 0) {
				new_game_button_text = <T>Create my first game</T>;
			} else {
				new_game_button_text = <T>Start a new game</T>;
			}
			sections.push(
				<Container key="blah">
					<div key="there_is_no_spoooooonz" className="container-fluid text-center">
						<Row>
							<Col className="pt-5">
								<img src="/gfx/pokal_m_flimmer-0.svg" className="img-fluid" alt="Time for a new game!"/>
							</Col>
						</Row>
						<Row>
							<Col>
								<div className="p-0 ad_no_games_header"><T>You have no active games</T></div>
								<div className="pt-0 pb-3 ad_no_games_text"><T>Start a new game. Invite and compete against your friends.</T></div>
								<div className="pb-4"><A href="/new_game"><Button className="ad_new_game_button ad_rbtn_25px py-2 px-5">{new_game_button_text}</Button></A></div>
							</Col>
						</Row>
					</div>
				</Container>
			);
		}
		if(IS_AKTIEDYSTEN_DK) {
			sections.push(
				<Container className="py-5" key="blup">
					<InspirationCards />
				</Container>
			);
		}

		for (const section of props.home.Sections) {
			var title;
			var key = "XXX";
			var items = [];

			const mk_stock_item = (asset) => {
				const key = `STOCK:${asset.Exchange}:${asset.Ticker}`;
				return (
					<Col key={key} md="3" className="p-3">
						<StockCard exchange={asset.Exchange} ticker={asset.Ticker} range="1m"/>
					</Col>
				);
			};

			const mk_portfolio_item = (portfolio) => {
				const key = `PORTFOLIO:${portfolio.Id}`;
				return (
					<Col key={key} md="3" className="p-3">
						<PortfolioCard range="1m" id={portfolio.Id}/>
					</Col>
				);
			}

			switch (section.Type) {
			case "COLLECTION":
				key = `COLLECTION:${section.Content.Id}`;
				title = <T>My shortlist</T>;
				items = (
					<Container fluid className="p-0 pt-4">
						<Row className="ad_game_box p-0">
							<Col className="py-4 pl-4" md="12">
								<div className="d-flex">
									<div className="ad_150pct"><b>{title}</b></div>
								</div>
							</Col>
							<Container fluid className="">
								<Row className="p-0 ad_game_card_box_bg">
									{section.Content.Assets.map(mk_stock_item)}
								</Row>
							</Container>
						</Row>
					</Container>
				);

				break;
			case "PORTFOLIOS":
				key = `PORTFOLIOS`;
				title = <T>My portfolios</T>;
				const refresh = () => {
					props.ctl.reload();
				}
				items = (
					<Container fluid className="p-0 py-4">
						<Row className="ad_game_box p-0">
							<Col className="py-4 pl-4" md="12">
								<div className="d-flex">
									<div className="ad_150pct"><b>{title}</b></div>
								</div>
							</Col>
							<Container fluid className="">
								<Row className="p-0 ad_game_card_box_bg">
									{section.Content.map(mk_portfolio_item)}
									<Col className="pb-4" md="12">
										<CreatePortfolio key="PORTFOLIO:CREATE" refresh={refresh}/>
									</Col>
								</Row>
							</Container>
						</Row>
					</Container>
				);

				break;
			default:
				continue;
			}

			sections.push(
				<Container fluid key={key}>
					{items}
				</Container>
			);
		};

		return (
			<Row className="pb-5">
				{sections}
			</Row>
		);
	};

	return (
		<div>
			{render_summary()}
			{render_other_stuff()}
		</div>
	);
}

PersonalHome = Apify("/a/home")
	.with_query_from_props((props) => ({
		today_start_ts: props.today_start_ts,
		active_game_portfolio_id: props.active_game_portfolio_id,
		lang: R.get_current_language(),
	}))
	.with_response_prop("home")
	.with_ctl_prop()
	.wrap(PersonalHome, ApifyFullScreenLoadingComponent);


var Home = (props) => {
	let bubbles_full = "/gfx/logo-bubbles-full-4.svg";
	let bubbles_mobile = "/gfx/logo-bubbles-mobile-1.svg";

	if (props.welcome) Twitter.welcome();

	let frontHeroImg = <img alt='smartphone' src='https://static.aktiedysten.dk/imgs/frontpage-mobilephone-530x450-0.webp'
				srcSet='https://static.aktiedysten.dk/imgs/frontpage-mobilephone-1060x900-0.webp 2x' />
	let frontHeroImgClasses = ' justify-content-end align-items-end';
	if(IS_AKTIEKAMPEN_SE) {
		frontHeroImg = <img alt='computer' src='https://static.aktiedysten.dk/imgs/frontpage_computer_ak_450x272_0.webp'
				srcSet='https://static.aktiedysten.dk/imgs/frontpage_computer_ak_900x544_0.webp 2x' />
		frontHeroImgClasses = ' justify-content-center align-items-center';
	}
	if(IS_INVESTSPIEL_DE) {
		frontHeroImg = <img alt='computer' src='https://static.aktiedysten.dk/imgs/frontpage_computer_is_450x272_0.webp'
				srcSet='https://static.aktiedysten.dk/imgs/frontpage_computer_is_900x544_0.webp 2x' />
		frontHeroImgClasses = ' justify-content-center align-items-center';
	}
	if(IS_TRADERR_COM) {
		frontHeroImg = <img alt='smartphone' src='https://static.aktiedysten.dk/imgs/frontpage-mobilephone-en-530x450-0.webp'
				srcSet='https://static.aktiedysten.dk/imgs/frontpage-mobilephone-en-1060x900-0.webp 2x' />
	}

	const render_chit_chat_when_not_logged_in = () => {
		return (
			<React.Fragment>
			<div className="ad_frontpage_top_blop">
			<Container className="pt-5">
				<Row>
					<Col xs="12" md="6" className="py-4">
						<div className="ad_front_heading" ><T>Who's the best investor?</T></div>
						<div className="ad_front_subheading pb-3"><T>Create a free investment game, invite your friends and compete for the title
						as the best investor.</T></div>
						<div className="py-4 text-center text-md-left">
							<BlessLink><Button href="/new_game" className="ad_new_game_button px-md-4 py-3">
								<span className="ad_first_game_btn_text px-5">
									<T>Start your first game</T>
								</span>
							</Button></BlessLink>
						</div>
						<RandomNumberGenerator/>
					</Col>
					<Col md="6" className={'d-none d-md-flex pr-3 m-0' + frontHeroImgClasses}>
						<div>
							{frontHeroImg}
						</div>
					</Col>
				</Row>
			</Container>
			</div>
			<div className="bg-white">
				<Container>
					<Row className="pt-5 pb-2 pb-md-5">
						<Col id="first_row_after_front_img" xs="12" md="4" className="text-center">
							<div className="py-4">
								<img alt="Compete" src="https://static.aktiedysten.dk/gfx/compete-icon-2023-0.svg"/>
							</div>
							<span className="ad_120_bold"><T>Compete and Win</T></span><br/>
							<p className="mt-2 mb-5 ad_gray_fg px-4 font-90">
								<T>Create a game, invite your friends and see who's the best investor</T>
							</p>
						</Col>
						<Col xs="12" md="4" className="text-center">
							<div className="py-4">
								<img alt="Portfolios" src="https://static.aktiedysten.dk/gfx/portfolio-icon-2023-0.svg"/>
							</div>
							<span className="ad_120_bold"><T>Create Portfolios</T></span><br/>
							<p className="mt-2 mb-5 ad_gray_fg px-4 font-90">
								<T>Create portfolios to track stocks and see how a potential investment would pan out</T>
							</p>
						</Col>
						<Col xs="12" md="4" className="text-center">
							<div className="py-4">
								<img alt="Learn" src="https://static.aktiedysten.dk/gfx/game-icon-2023-0.svg"/>
							</div>
							<span className="ad_120_bold"><T>Play and Learn</T></span><br/>
							<p className="mt-2 mb-5 ad_gray_fg px-4 font-90">
								<T>Learn to invest by trying it out as it would be in real life investing</T>
							</p>
						</Col>
					</Row>
				</Container>
			</div>
			{IS_AKTIEDYSTEN_DK &&
			<div className="bg-white pb-5">
				<Container>
					<DynamicBiatheElems />
				</Container>
			</div>
			}
			<PublicGames show_placeholder_if_empty={false} use_xtab={false}/>
			<Container>
				<QuotesFromPeople />
			</Container>
			{IS_AKTIEDYSTEN_DK &&
				<div className='pb-5'>
					<Container className="py-4">
						<InspirationCards />
					</Container>
				</div>
			}
			<div className='thousands_to_invest_in px-3 mb-5'>
				<div className="text-center">
					<div className="ad_front_heading pt-5 fw_800"><T>Thousands of companies you can invest in</T></div>
				</div>
				<div className='d-flex flex-row justify-content-center'>
					<div className='ad_width_33_rem text-center'>
						<T>
							At {site_name} you can invest in <A href='/explore'>thousands_stocks</A>
						</T>
					</div>
				</div>
				<div className="d-none d-md-block pt-5" style={{position: 'relative', width: "100vw", marginLeft: "-50vw", left: "50%"}}>
					<InlineSVG className="ad_frontpage_scale_imgs" alt="companies" src={bubbles_full}/>
				</div>
				<div className="d-block d-md-none text-center pt-5">
					<InlineSVG className="ad_frontpage_scale_imgs" alt="companies" src={bubbles_mobile}/>
				</div>
				<Col className="py-5 text-center" xs="12">
					<A href="/explore"><Button className="ad_new_game_button px-md-4 py-3"><span className="ad_first_game_btn_text px-5"><b><T>Find more assets</T></b></span></Button></A>
				</Col>
			</div>


			</React.Fragment>
		);
	}

	const today_start_ts = ((new Date()).setHours(0,0,0,0)/1000)|0;

	var content;
	if (props.me) {
		content = (
			<React.Fragment>
				<Container className="p-md-0">
					<SkinWrapperByGameOrPortfolioId portfolio_id={props.active_game_portfolio_id}>
						<PersonalHome today_start_ts={today_start_ts} {...props}/>
					</SkinWrapperByGameOrPortfolioId>
				</Container>
			</React.Fragment>
		);
	} else {
		content = render_chit_chat_when_not_logged_in();
	}

	return (
		<span>
			{props.welcome ? Linkedin.welcome_pixel() : null}
			{content}
		</span>
	);
}

Home = connect(
	(state) => ({
		me: state.me,
		active_game_portfolio_id: state.LastGamePortfolioIdVisited || 0,
	})
)(Home);

const Welcome = (props) => <Home {...props} welcome={true}/>;

export { Home, Welcome };



// WEBPACK FOOTER //
// ./src/p/Home.js